import { render, staticRenderFns } from "./productsIndex.vue?vue&type=template&id=948cada4&"
import script from "./productsIndex.vue?vue&type=script&lang=js&"
export * from "./productsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports